(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/prolong-game.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/prolong-game.js');

'use strict';

const _svs$numbergames$prol = svs.numbergames.prolong_game,
  ProlongProvider = _svs$numbergames$prol.context.ProlongProvider,
  ProlongBottomSheet = _svs$numbergames$prol.components.ProlongBottomSheet,
  trackCloseProlongDialog = _svs$numbergames$prol.analytics.trackCloseProlongDialog;
const ProlongGame = _ref => {
  let wager = _ref.wager,
    onOpenClose = _ref.onOpenClose,
    trackingCategory = _ref.trackingCategory,
    onSuccessCb = _ref.onSuccessCb,
    onDoneCb = _ref.onDoneCb,
    onCancelCb = _ref.onCancelCb,
    getAfterChangeReturnUrl = _ref.getAfterChangeReturnUrl;
  return React.createElement(ProlongProvider, {
    wager: wager,
    trackingCategory: trackingCategory,
    onSuccessCb: onSuccessCb,
    onDoneCb: onDoneCb,
    onCancelCb: onCancelCb,
    getAfterChangeReturnUrl: getAfterChangeReturnUrl
  }, React.createElement("div", {
    className: "prolong-game-container"
  }, React.createElement(ProlongBottomSheet, {
    behavior: "modal",
    isFixed: true,
    headerTitle: "F\xF6rl\xE4ng spel",
    onStateChange: newState => {
      if (newState.state === 'closed') {
        trackCloseProlongDialog(trackingCategory);
        onOpenClose({
          isOpen: false
        });
      }
    }
  })));
};
setGlobal('svs.numbergames.prolong_game.ProlongGame', ProlongGame);

 })(window);